let wsURL = 'wss://devmsg.cias.cn/ws/'
let rsappPath = 'http://localhost.cias.cn:8080'
let apiKey = '/'

const host = window.location.host

export const isPRD = host === 'renshang.cias.cn'

export const isUAT = host === 'uatrenshang.cias.cn'

export const isTest = host === 'testrenshang.cias.cn'

export const isDEV = host === 'devrenshang.cias.cn'

export const isLocal = process.env.NODE_ENV === 'development'

if (isPRD) {
	wsURL = 'wss://msg.cias.cn/ws/'
} else if (isUAT) {
	wsURL = 'wss://uatmsg.cias.cn/ws/'
} else if (isTest) {
	wsURL = 'wss://testmsg.cias.cn/ws/'
}

if (isPRD) {
	rsappPath = 'https://rsapp.cias.cn/hybrid'
} else if (isUAT) {
	rsappPath = 'https://uatrsapp.cias.cn/hybrid'
} else if (isTest) {
	rsappPath = 'http://testrsapp.cias.cn/hybrid'
} else if (isDEV) {
	rsappPath = 'http://devrsapp.cias.cn/hybrid'
}

if (isLocal) {
	apiKey = '/api'
}

export { wsURL, rsappPath, apiKey }
